var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48 5.5V7.5L9.24 12.5L14 7.5V5.5L9.24 10.5L4.48 5.5Z",
    fill: "#9EA2AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowProfile);
export default __webpack_public_path__ + "static/media/ic-arrow-profile.d91fc11abd8e69f97e30d87eb1576a02.svg";
export { ForwardRef as ReactComponent };